import {
	EmailOutlineIcon,
	FacebookMessengerIcon,
	FacebookRegularIcon,
	InstagramIcon,
	NextDoorIcon,
	TextSmsIcon,
	TwitterIcon,
	WhatsAppIcon,
} from '@change/ds-icons';

export const CHANNEL_META = {
	facebook: {
		Icon: FacebookRegularIcon,
		className: 'bg-[#1877F2] text-icon-inverse-strong',
	},
	instagram: {
		Icon: InstagramIcon,
		className:
			'bg-[linear-gradient(45deg,#FFD521_14.64%,#FFD020_18.54%,#FEC01E_23.42%,#FCA71B_28.82%,#FA8316_34.59%,#F85510_40.67%,#F51E09_46.91%,#F30005_50%,#F20007_50.25%,#E1003B_56.83%,#D30067_63.29%,#C70088_69.49%,#BF00A0_75.38%,#BB00AF_80.81%,#B900B4_85.36%)] text-icon-inverse-strong',
	},
	whatsapp: {
		Icon: WhatsAppIcon,
		className: 'bg-[#25D366] text-icon-inverse-strong',
	},
	nextdoor: {
		Icon: NextDoorIcon,
		className: 'bg-white text-[#1b8751]',
	},
	twitter: {
		Icon: TwitterIcon,
		className: 'bg-fill-strong text-icon-inverse-strong',
	},
	facebookMessenger: {
		Icon: FacebookMessengerIcon,
		className: 'bg-[#0080F7] text-icon-inverse-strong',
	},
	email: {
		Icon: EmailOutlineIcon,
		className: 'bg-fill-weaker text-icon-strong',
	},
	sms: {
		Icon: TextSmsIcon,
		className: 'bg-fill-weaker text-icon-strong',
	},
} as const;

export const SUPPORTED_CHANNELS = [
	'facebook',
	'instagram',
	'whatsapp',
	'nextdoor',
	'twitter',
	'facebookMessenger',
	'email',
	'sms',
];
